/**
 * One `session_id` per app load (ARCHITECTURE.md §4 Recording.session_id).
 * T5↔T6 pairs must be recorded in the same session, so it lives in
 * sessionStorage: it survives a reload of the same tab, not a new tab.
 */
const KEY = "xz.session_id";

function randomId(): string {
  const g = globalThis.crypto;
  if (g && typeof g.randomUUID === "function") return g.randomUUID();
  if (g && typeof g.getRandomValues === "function") {
    const b = new Uint8Array(16);
    g.getRandomValues(b);
    return Array.from(b, (x) => x.toString(16).padStart(2, "0")).join("");
  }
  return `s-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

let cached: string | null = null;

/** Stable id for this browsing session. */
export function getSessionId(): string {
  if (cached) return cached;
  try {
    const stored = sessionStorage.getItem(KEY);
    if (stored) {
      cached = stored;
      return stored;
    }
  } catch {
    /* private mode / storage disabled — fall through to an in-memory id */
  }
  const id = randomId();
  cached = id;
  try {
    sessionStorage.setItem(KEY, id);
  } catch {
    /* ignore */
  }
  return id;
}

/** Test helper: forget the cached id (does not clear storage). */
export function resetSessionIdCache(): void {
  cached = null;
}
